import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authReducer";
import { globalMessageReducer } from "@sait-fe-core";
import { moduleReducer } from "@sait-fe-core";
import { globalLoadingReducer } from "@sait-fe-core";
import { globalConfirmReducer } from "@sait-fe-core";
import { generalConfigReducer } from "@sait-fe-core";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		module: moduleReducer,
		globalMessage: globalMessageReducer,
		globalLoading: globalLoadingReducer,
		globalConfirm: globalConfirmReducer,
		generalConfig: generalConfigReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});
